<template>
  <ModalForm
    :modal="modal"
    :show="showModal"
    :successModalData="successModalData"
    @handleModal="handleContactUsModal"
  />
  <section class="location-details container">
    <div
      class="location-details__content"
      v-if="locationDetails.content"
      v-html="locationDetails.content"
    ></div>
    <div class="row justify-content-between flex-column-reverse flex-md-row">
      <div class="col-12 col-md-3">
        <div class="location-details__info-container">
          <h5>{{ locationDetails.locationNameMap }}</h5>
          <div v-if="locationDetails.address1">
            {{ locationDetails.address1 }}
          </div>
          <div v-if="locationDetails.address2">
            {{ locationDetails.address2 }}
          </div>
          <div>{{ locationDetails.city }}, {{ locationDetails.state }}</div>
          <div>{{ locationDetails.postalCode }}</div>
        </div>
        <div
          class="location-details__info-container"
          v-html="locationDetails.openingHours"
        ></div>
        <div class="location-details__btn-container">
          <ButtonRed
            v-if="locationDetails.phone"
            class="location-details__btn"
            :text="locationDetails.phone"
            :phone="locationDetails.phone"
          />
          <ButtonRed
            class="location-details__btn"
            text="Contact US"
            @click="handleContactUsModal"
          />
        </div>
        <div
          class="location-details__googleMaps-container d-flex flex-column align-items-center align-items-md-start"
          v-if="locationDetails.googleMapsLink"
        >
          <p class="location-details__googleMaps-title mb-0 text-center">
            {{ locationDetails.googleMapsTitle }}:
          </p>
          <Link :href="locationDetails.googleMapsLink">
            <div class="location-details__googleMaps">
              <GoogleMapsIcon height="50" width="100%" />
            </div>
          </Link>
        </div>
      </div>

      <div class="col-12 col-md-8">
        <div class="location-details__map">
          <GMapMap
            :center="{
              lat: locationDetails.latitude,
              lng: locationDetails.longitude,
            }"
            :zoom="15"
            class="h-100"
            :mapPlaceholderImage="locationDetails.mapPlaceholderImage"
            :options="options"
          >
            <GMapMarker
              :position="{
                lat: locationDetails.latitude,
                lng: locationDetails.longitude,
              }"
            />
          </GMapMap>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import GoogleMapsIcon from "@/assets/icons/google-maps-icon";
import ButtonRed from "@/components/common/ButtonRed.vue";
import Link from "@/components/common/Link";
import ModalForm from "@/components/common/modals/ModalForm.vue";
import { ref } from "vue";

const props = defineProps({
  locationDetails: {
    locationName: String,
    isBannerExist: Boolean,
    content: HTMLElement,
    address1: String,
    address2: String,
    city: String,
    state: String,
    postalCode: String,
    openingHours: HTMLElement,
    phone: String,
    contactUrl: String,
    googleMapsTitle: String,
    googleMapsLink: String,
    latitude: Number,
    longitude: Number,
    mapPlaceholderImage: String,
  },
  modal: Object,
  successModalData: Object,
});

const showModal = ref(false);

const handleContactUsModal = () => (showModal.value = !showModal.value);
</script>
